import React from "react";
import ReactDOM from "react-dom/client";

import { loadClarity } from "../../../packages/frontend-runtime/clarity";
import { recoverFromStaleBuild } from "../../../packages/frontend-runtime/staleBuild";
import { App } from "./App";
import "./index.css";

recoverFromStaleBuild();

// The public site's own Clarity project, Balanced because the site carries no
// personal data; the panel loads a separate Strict project from its own entry.
// Section 10 of `public/privacidade.html` is where both are disclosed.
loadClarity("yionnsmsg5");

// Opt into scroll-reveal hiding only when JS is running, set before first
// paint so there's no flash — and so content stays visible if JS never loads.
document.documentElement.classList.add("reveal-on");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
